// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s-5I","top":"styles_top__2FDHj","left":"styles_left__M7v-0","description":"styles_description__82zJF"};